// extracted by mini-css-extract-plugin
export default {"switcherContainer":"LanguageSwitcher_switcherContainer__dwtJ4","switcherBtn":"LanguageSwitcher_switcherBtn__CKe7X"};